import React from 'react'
import StatisticCard from './StatisticCard'
import useReviewedSubmissionsStats from '../../../../components/assignment-header/question-progress/useReviewedSubmissionsStats'

const FullyReviewedCard = () => {
    const { reviewed, total, isLoading, error } = useReviewedSubmissionsStats()

    const getAdditionalContent = () => {
        if (total === 0) return ["No students yet 📋"]
        
        const percentage = (reviewed / total) * 100
        
        if (percentage === 0) {
            return ["Time to dive in! 📚"]
        } else if (percentage <= 25) {
            return ["Getting started 🌱"]
        } else if (percentage <= 50) {
            return ["Steady progress 📊"]
        } else if (percentage <= 75) {
            return ["Looking good! 👍"]
        } else if (percentage <= 90) {
            return ["Nearly finished! ⭐"]
        } else {
            return ["Outstanding! 🏆"]
        }
    }

  return <StatisticCard
  title="Students Reviewed"
  value={reviewed}
  suffix={`/ ${total}`}
  //trend={`${percentage}%`} to be added later
  trendType="success"
  additionalContent={getAdditionalContent()}
  loading={isLoading}
  error={error}
/>
}

export default FullyReviewedCard